export default authCode => {
  const validateAuthCode = new RegExp('^[a-zA-Z0-9\\/:. -]{0,52}$');
  return validateAuthCode.test(authCode) || !authCode;
};
